import { Cookies } from 'react-cookie';

import { EmailNotifyValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface putchEmailNotifyProps {
  objectSlug?: string;
  notify: EmailNotifyValues;
}

export const putchEmailNotify = async (info: putchEmailNotifyProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.patch(
    `/objects/${info.objectSlug}/update-email-notifications/`,
    {
      ...info.notify,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
